import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Menu, X, Mail, Phone, Linkedin, Twitter } from "lucide-react";

const LINKS = [
  { to: "/#ecosystem", label: "Ecosystem" },
  { to: "/#engine", label: "Intelligence Engine" },
  { to: "/#programs", label: "Programs" },
  { to: "/#access", label: "Access & Tiers" },
];

export default function PublicNav() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50">
      {/* Top utility bar */}
      <div className="hidden md:block bg-[#0D3C4C] text-[#FEF7E7]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-9 flex items-center justify-between text-[11px] tracking-wide">
          <div className="flex items-center gap-5">
            <span className="inline-flex items-center gap-1.5"><Mail className="w-3.5 h-3.5 text-[#F0A315]" /> concierge@n360.network</span>
            <span className="inline-flex items-center gap-1.5"><Phone className="w-3.5 h-3.5 text-[#F0A315]" /> +91 (0) 22 6000 3600</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-[#FEF7E7]/70">Trusted. Connected. Impactful.</span>
            <span className="flex items-center gap-3 pl-3 border-l border-white/15">
              <a href="#" aria-label="LinkedIn" className="hover:text-[#F0A315] transition-colors"><Linkedin className="w-3.5 h-3.5" /></a>
              <a href="#" aria-label="X" className="hover:text-[#F0A315] transition-colors"><Twitter className="w-3.5 h-3.5" /></a>
              <a href="#" aria-label="Mail" className="hover:text-[#F0A315] transition-colors"><Mail className="w-3.5 h-3.5" /></a>
            </span>
          </div>
        </div>
      </div>

      {/* Main bar */}
      <div className="backdrop-blur-xl bg-[#FEF7E7]/90 border-b border-[#EADFC7]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[68px] flex items-center justify-between">
          <Link to="/" data-testid="nav-brand-logo" className="flex items-center gap-2.5 group">
            <span className="relative w-9 h-9 grid place-items-center">
              <span className="absolute inset-0 rounded-lg crest-ring spin-slow opacity-70" />
              <span className="absolute inset-[1.5px] rounded-[7px] bg-[#FFFFFF] grid place-items-center font-display text-[#F1551D] text-sm">N</span>
            </span>
            <span className="font-display text-xl tracking-wide text-[#0D3C4C]">N<span className="gold-text">360</span></span>
          </Link>

          <nav className="hidden lg:flex items-center gap-9 absolute left-1/2 -translate-x-1/2">
            {LINKS.map((l) => (
              <a key={l.label} href={l.to} data-testid={`nav-link-${l.label}`} className="text-sm font-medium text-[#154859] hover:text-[#F1551D] transition-colors tracking-wide">
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            {user ? (
              <button data-testid="nav-portal-btn" onClick={() => navigate("/app")} className="px-6 py-2.5 rounded-full text-sm font-semibold btn-gold">
                Enter Portal
              </button>
            ) : (
              <>
                <button data-testid="nav-login-btn" onClick={() => navigate("/login")} className="text-sm font-medium text-[#154859] hover:text-[#F1551D] transition-colors">Sign In</button>
                <button data-testid="nav-signup-btn" onClick={() => navigate("/signup")} className="px-6 py-2.5 rounded-full text-sm font-semibold btn-gold">
                  Request Clearance
                </button>
              </>
            )}
          </div>

          <button className="lg:hidden text-[#154859]" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-b border-[#EADFC7] bg-[#FEF7E7] px-5 py-4 space-y-3">
          {LINKS.map((l) => (
            <a key={l.label} href={l.to} onClick={() => setOpen(false)} className="block text-[#154859] hover:text-[#F1551D]">{l.label}</a>
          ))}
          <div className="flex gap-3 pt-2">
            {user ? (
              <button onClick={() => navigate("/app")} className="flex-1 px-4 py-2 rounded-full text-sm btn-gold font-semibold">Enter Portal</button>
            ) : (
              <>
                <button onClick={() => navigate("/login")} className="flex-1 px-4 py-2 rounded-full text-sm border border-[#F1551D]/40 text-[#154859]">Sign In</button>
                <button onClick={() => navigate("/signup")} className="flex-1 px-4 py-2 rounded-full text-sm btn-gold font-semibold">Join</button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
